import React, { useState } from 'react';
import PropTypes, { any } from 'prop-types';
import { RadioGroup, Radio } from 'react-form';
import isEmpty from 'lodash/isEmpty';

import { Input, Location } from '../Form';
import { eventQuestionTypeIds, flexLeagueHomeCourtDescription } from '../../utils/eventConstants';

const EventQuestion = (props) => {
    const { label, field, validate, answer, typeId, values, errors, asyncValidate, asyncErrors, submitting, disableProfanityCheck, isPartner, user, required } = props;

    const claimedPlayer = user?.claimedPlayer || {};
    const [isHomeCourtChosenFromDropdown, setIsHomeCourtChosenFromDropdown] = useState(
        !(isEmpty(claimedPlayer.homeCourt) || isEmpty(claimedPlayer.homeClub)),
    );

    const handleHomeCourtChange = () => setIsHomeCourtChosenFromDropdown(true);

    const handleHomeCourtSelect = () => setIsHomeCourtChosenFromDropdown(true);

    if (typeId === eventQuestionTypeIds.HOME_COURT && isPartner) {
        return null;
    }

    if (typeId === eventQuestionTypeIds.MULTIPLE_CHOICE) {
        const options = JSON.parse(answer);
        const fieldValue = values[field];
        return (
            <RadioGroup
                field={field}
                validate={validate}
            >
                <label className={`label text-black`}>
                    {label}
                </label>
                {(Array.isArray(options) ? options : []).map(({ option }) => (
                    <div className="d-flex aic mb8" key={`${field}-${option}`}>
                        <Radio
                            key={`${field}-${option}`}
                            id={`${field}-${option}`}
                            value={option}
                            checked={fieldValue === option}
                        />
                        <label htmlFor={`${field}-${option}`} className="mb0">&nbsp;{option}</label>
                    </div>
                ))}
                {!!errors?.[field] && <div className="d-flex aic mb8 invalid-feedback">{errors?.[field]}</div>}
            </RadioGroup>
        );
    }
    if (typeId === eventQuestionTypeIds.HOME_COURT) {
        const locationInputProps = {
            placeholder: 'Location (zip or city)',
            name: 'location',
        };

        const validateHomeCourt = (value) => {
            let error = '';

            if (isEmpty(value)) {
                error = 'Please select home court';
            }

            return error || null;
        };

        return (
            <Location
                label={label}
                id={field}
                field={field}
                description={flexLeagueHomeCourtDescription}
                inputProps={locationInputProps}
                handleChange={handleHomeCourtChange}
                handleSelect={handleHomeCourtSelect}
                useDynamicOption={true}
                showMap={false}
                placeholder="Home Court"
                validate={required && validateHomeCourt}
            />
        );
    }
    return (
        <Input
            label={label}
            field={field}
            type="text"
            validate={validate}
            asyncValidate={asyncValidate}
            asyncErrors={asyncErrors}
            submitting={submitting}
            disableProfanityCheck={disableProfanityCheck}
        />
    );
};

EventQuestion.defaultProps = {
    validate: () => { },
    answer: null,
    asyncErrors: {},
    asyncValidate: () => { },
    submitting: null,
    disableProfanityCheck: false,
    isPartner: false,
    required: false,
};

EventQuestion.propTypes = {
    label: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired,
    validate: PropTypes.func,
    answer: PropTypes.string,
    typeId: PropTypes.number.isRequired,
    values: PropTypes.objectOf(any).isRequired,
    asyncErrors: PropTypes.shape({}),
    asyncValidate: PropTypes.func,
    submitting: PropTypes.bool,
    disableProfanityCheck: PropTypes.bool,
    isPartner: PropTypes.bool,
    user: PropTypes.objectOf(any).isRequired,
    required: PropTypes.bool,
};

export default EventQuestion;
